import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AssetPathModule, PxToRemModule } from '@hdms/shared/util-core';

import { ImageComponent } from './image.component';
import { SecureImageDirective } from './secure-image.directive';

@NgModule({
  declarations: [ImageComponent, SecureImageDirective],
  imports: [CommonModule, AssetPathModule, PxToRemModule],
  exports: [ImageComponent, SecureImageDirective]
})
export class ImageModule {}

export * from './image.component';
export * from './secure-image.directive';
